import React, { FC } from "react";
import { IMensagemAtribuicao } from "@deltasge/marauders-map";
import { Badge, Tab } from "@mui/material";
import { TabList } from "@mui/lab";

import { history } from "configs";
import { utilMensagem as util } from "../../utilMensagem";

export const Tabs: FC<{
  mensagemAtribuicoes: IMensagemAtribuicao[];
  tab: string;
  idMensagem: number;
  unreadsAlunos: number;
  unreadsResponsaveis: number;
  unreadsLoginExtras: number;
  unreadsProfessores: number;
}> = ({
  mensagemAtribuicoes,
  tab,
  idMensagem,
  unreadsAlunos,
  unreadsResponsaveis,
  unreadsLoginExtras,
  unreadsProfessores,
}) => {
  return (
    <TabList
      value={tab}
      onChange={(_, tab) => {
        history.push(`/publicacoes/detalhes/${idMensagem}/tab/${tab}`);
      }}
      aria-label="Tabs"
      textColor="inherit"
      indicatorColor="secondary"
    >
      <Tab label="Detalhes" value="1" />
      {util.showTabDetalhesMensagem({
        atr: mensagemAtribuicoes,
        tipo: "aluno",
      }) && (
        <Tab
          label={
            <Badge badgeContent={unreadsAlunos} color="secondary">
              Alunos
            </Badge>
          }
          value="2"
        />
      )}
      {util.showTabDetalhesMensagem({
        atr: mensagemAtribuicoes,
        tipo: "responsavel",
      }) && (
        <Tab
          label={
            <Badge badgeContent={unreadsResponsaveis} color="secondary">
              Responsáveis
            </Badge>
          }
          value="3"
        />
      )}
      {util.showTabDetalhesMensagem({
        atr: mensagemAtribuicoes,
        tipo: "loginExtra",
      }) && (
        <Tab
          label={
            <Badge badgeContent={unreadsLoginExtras} color="secondary">
              Logins extras
            </Badge>
          }
          value="4"
        />
      )}
      {util.showTabDetalhesMensagem({
        atr: mensagemAtribuicoes,
        tipo: "professor",
      }) && (
        <Tab
          label={
            <Badge badgeContent={unreadsProfessores} color="secondary">
              Professores
            </Badge>
          }
          value="5"
        />
      )}
    </TabList>
  );
};
